<template>
  <div class="box">
    <p class="titleModal mb-0">
      {{ $t(`treatmentProgram.step2.type`) }}
    </p>
    <v-row class="">
      <v-col class="noYPadding">
        <VSelect
          v-model="data.probeType"
          :label="$t('treatmentProgram.step2.type')"
          :items="displayedUnits('probeType')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="cycleType"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'Schedule',
    props: {
        model: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        ...mapGetters([
            'treatmentProgramUnits',
        ]),
    },
    watch: {
        model: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.model) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { probe: this.data });
        },
        displayedUnits(type) {
            return this.treatmentProgramUnits && this.treatmentProgramUnits[type]
                ? this.treatmentProgramUnits[type] : [];
        },
        isTrue(property) {
            return property === 0;
        },
    },
};
</script>
<style lang="scss" scoped>
.noYPadding {
    padding-bottom: 0px;
    padding-top: 0px;
}
.box {
    width: 100%;
    padding: 0 1rem;
}
.xPadding{
  padding: 0 6rem;
}
</style>
